<template>
  <div class="redeem_prizes_toast_bg" v-show="toastShow">
    <div class="redeem_prizes_toast_centent_bg">
      <div class="redeem_prizes_toast_header">
        <img
          class="redeem_prizes_toast_header_image"
          v-if="dataModel != null"
          :src="dataModel.picture"
        />
        <div class="redeem_prizes_toast_header_tit">兑换信息</div>
        <div class="redeem_prizes_toast_header_name" v-if="dataModel != null">
          {{ dataModel.name }}
        </div>
      </div>
      <div class="redeem_prizes_toast_addr_title">填写收件信息</div>
      <input
        class="redeem_prizes_toast_addr_input"
        type="text"
        v-model="name"
        maxlength="10"
        @keyup.enter="inputName"
        @input="inputName()"
        placeholder="收件人姓名"
      />
      <input
        class="redeem_prizes_toast_addr_input"
        type="text"
        v-model="phone"
        maxlength="11"
        minlength="11"
        @keyup.enter="inputPhone"
        @input="inputPhone()"
        oninput="value = value.replace(/[^0-9]/g,'')"
        placeholder="联系电话"
      />
      <textarea
        class="redeem_prizes_toast_addr_input"
        maxlength="36"
        v-model="address"
        @keyup.enter="inputAdd"
        @input="inputAdd($event)"
        placeholder="收件地址"
      />
      <button
        :class="{ redeem_prizes_toast_addr_button_red: isDown }"
        class="button redeem_prizes_toast_addr_button"
        @click="redeemPrizes"
      >
        确定
      </button>
      <button
        class="button lottery_image_toast_close"
        @click="$emit('isshowaction')"
      >
        <img
          class="lottery_image"
          src="../../assets/lottery/close_icon.png"
          alt="关闭"
        />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { openToast } from "toast-ts";
import { PrizeModel } from "../../model/lottery/LotteryModel";
@Options({
  props: {
    toastShow: Boolean
  },
  emits: {
    isshowaction: () => {
      return true;
    },
    reloadData: () => {
      return true;
    }
  }
})
export default class RedeemPrizesToast extends Vue {
  private dataModel: PrizeModel | null = null;
  mounted() {
    this.getPrizeData();
  }
  getPrizeData() {
    Http.get<PrizeModel>(Urls.lottery_luckyValueAward).then(
      (res: PrizeModel) => {
        this.dataModel = res;
      },
      (err: ResponseData) => {
        console.log("RedeemPrizesToast:", err.message);
        // openToast(err.message);
      }
    );
  }

  /// 确定的背景颜色
  isDown = false;
  name = "";
  phone = "";
  address = "";
  inputName() {
    this.isDownAction();
  }
  inputPhone() {
    this.isDownAction();
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputAdd(event: any) {
    event;
    this.isDownAction();
  }
  isDownAction() {
    if (
      this.name.length > 0 &&
      this.phone.length == 11 &&
      this.address.length > 0
    ) {
      this.isDown = true;
    } else {
      this.isDown = false;
    }
  }
  redeemPrizes() {
    if (!this.isDown) return;
    const data = {
      type: 2,
      contactPhone: this.phone,
      contactAddr: this.address,
      contactPerson: this.name
    };
    Http.post<string>(Urls.lottery_order, data).then(
      () => {
        openToast("兑换成功");
        // eslint-disable-next-line vue/custom-event-name-casing
        this.$emit("reloadData");
      },
      () => {
        openToast("兑换失败，查看具体原因，请联系客服。");
      }
    );
  }
}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.redeem_prizes_toast_bg {
  position: fixed;
  z-index: 2000;
  left: 0px;
  right: 0;
  top: 44px;
  bottom: 0;
  text-align: center;
  background: rgba(17, 17, 17, 0.7);
  height: 100%;
  width: 100%;
  .redeem_prizes_toast_centent_bg {
    width: 325px;
    height: 436px;
    position: fixed;
    z-index: 2100;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    border-radius: 10px;
    background-color: white;
    .redeem_prizes_toast_header {
      height: 80px;
      // background-color: yellow;
      border-radius: 10px 10px 0px 0px;
      padding-top: 20px;
      padding-left: 20px;
      padding-right: 20px;
      .redeem_prizes_toast_header_tit {
        width: 194px;
        float: right;
        text-align: left;
        color: #111111;
        font-weight: bold;
        font-size: 15px;
      }
      .redeem_prizes_toast_header_name {
        float: right;
        width: 194px;
        padding-top: 8px;
        text-align: left;
        color: #111111;
        font-size: 14px;
      }
      /// 图片
      .redeem_prizes_toast_header_image {
        float: left;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        height: 80px;
        width: 80px;
        border-radius: 10px;
        object-fit: cover;
      }
    }

    /// 输入框
    .redeem_prizes_toast_addr_title {
      text-align: left;
      margin-top: 20px;
      margin-left: 20px;
      margin-right: 20px;
      font-weight: bold;
      font-size: 14px;
    }
    .redeem_prizes_toast_addr_input {
      width: 255px;
      margin-top: 10px;
      padding: 15px 15px 15px 15px;
      background-color: #f6f6f6;
      border: 0px solid transparent;
      border-radius: 5px;
      outline: none; // 去除选中状态边框
      word-wrap: break-word;
      font-size: 14px;
    }
    .redeem_prizes_toast_addr_button {
      padding: 10px 85px;
      background-color: #cccccc;
      font-size: 15px;
      color: #ffffff;
      border-radius: 30px;
      margin-top: 20px;
    }
    .redeem_prizes_toast_addr_button_red {
      background-color: #f64746;
    }
    .lottery_image_toast_close {
      position: fixed;
      z-index: 2200;
      left: 50%;
      bottom: -70px;
      color: #ffffff;
      transform: translateX(-50%) translateY(-50%);
      text-align: center;
      .lottery_image {
        width: 36px;
        height: 36px;
      }
    }
  }
}
</style>
